import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { axiosOpen } from "../../api/axios";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { toast, Toaster } from 'react-hot-toast';

const CheckoutForm = ({ planDetails, isProcessingPayment, setIsProcessingPayment }) => {
  let subscriber = {};
  let requestBody = {};
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const userID = localStorage.getItem('userID');
  const { email, fname, lname } = JSON.parse(localStorage.userDetails);

  const handleSubmit = async (event) => {
    event.preventDefault();
    // setIsProcessingPayment(true);
    setLoading(true)
    try {
      const res = await stripe.createToken(elements.getElement(CardElement));
      requestBody = {
        planId: planDetails.planId,
        name: `${fname} ${lname}`,
        email: email,
        token: res.token.id,
      };
      subscriber = await axiosOpen.post(`subscriber/create`, {
        ...requestBody,
      });
      setLoading(false);
      setIsProcessingPayment('completed');
    } catch (err) {
      if (err?.response?.data?.status === "failed") {
        toast.error(err.response.data.message);
      }
      setTimeout(() => { setLoading(false); setIsProcessingPayment('failed'); }, 5000);
    }
  };


  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Form onSubmit={handleSubmit} className="add-user-form add-plans">
        <Form.Group className="mb-3 stripe-card" controlId="formBasicAmount">
          <CardElement />
        </Form.Group>
        <div className="text-center mt-4">
          <Button variant="primary" type="submit" className="custom-btn" disabled={loading} >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" role="status" />
                <span className="sr-only">Processing...</span>
              </>
            ) : (
              'Pay'
            )}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default CheckoutForm;
